import React from 'react';

const STEPS = [
  { n: 1, label: 'Schools' },
  { n: 2, label: 'Factors' },
  { n: 3, label: 'Your Ratings' },
  { n: 4, label: 'Objective Data' },
  { n: 5, label: 'Results' },
];

const HAT_STEPS = [
  { n: 1, label: 'Contenders' },
  { n: 2, label: 'Judgment' },
  { n: 3, label: 'Instincts' },
  { n: 4, label: 'Records' },
  { n: 5, label: 'Verdict' },
];

export default function StepIndicator({ currentStep, hpTheme = false }) {
  const steps = hpTheme ? HAT_STEPS : STEPS;
  return (
    <div className="step-indicator">
      {steps.map((s, i) => {
        const status = currentStep > s.n ? 'completed' : currentStep === s.n ? 'active' : 'inactive';
        return (
          <React.Fragment key={s.n}>
            {i > 0 && (
              <div className={`step-connector ${currentStep > s.n ? 'completed' : ''}`} />
            )}
            <div className="step-item">
              <div className={`step-circle ${status}`}>
                {status === 'completed' ? '✓' : s.n}
              </div>
              {!hpTheme && <span className={`step-label ${status}`}>{s.label}</span>}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
